<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
export default {
  name: "App",
  methods: {
    ...mapMutations(["modleChange"])
  },
  created() {
    var clientWidth = document.documentElement.clientWidth;
    if (clientWidth <= 750) {
      this.modleChange("mobile");
    } else {
      this.modleChange("window");
    }
    window.onresize = () => {
      var clientWidth = document.documentElement.clientWidth;
      if (clientWidth <= 750) {
        this.modleChange("mobile");
        //this.$store.state.modleFlag = "mobile";
      } else {
        //this.$store.state.modleFlag = "window";
        this.modleChange("window");
      }
    };
  }
};
</script>

<style lang="scss">
input,
div,
i,
a,
span,
button,
textarea {
  font-family: "Microsoft YaHei", "微软雅黑", "Arial", "Cuntery Gothic",
    "Helvetica" !important;
}
* {
  margin: 0;
  padding: 0;
}
ul,
li {
  list-style: none;
}
#app {
  font-family: "微软雅黑", "Microsoft YaHei", "黑体", "SimHei", "PingFangSC",
    "PingFang", Helvetica, sans-serif, "Avenir", Arial;
  position: relative;
  width: 100%;
  height: 100%;
  //overflow: auto;
}
html,
body,
#app {
  padding: 0;
  margin: 0;
  // filter: grayscale(1);
  //background: #fff;
}
body {
  width: 100%;
  height: 100%;
  overflow-x: hidden;
}
// body::-webkit-scrollbar {
//   display: none;
// }

.btn1 {
  border: 1px #ffffff solid;
  outline: none;
  border-radius: 0.02rem;
  background: none;
  min-width: 1.38rem;
  height: 0.29rem;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: #ffffff;
  font-size: 0.16rem;
  cursor: pointer;

  padding: 0 0.2rem;
  white-space: nowrap;
}
.btn1:hover {
  background: #ffffff;
  color: #c71628;
}
.btn2 {
  border: 1px #ffffff solid;
  outline: none;
  border-radius: 0.02rem;
  background: #ffffff;
  min-width: 1.38rem;
  height: 0.29rem;
  align-items: center;
  justify-content: center;
  text-align: center;
  text-align: center;
  color: #c71628;
  font-size: 0.16rem;
  cursor: pointer;
  padding: 0 0.2rem;
  white-space: nowrap;
}
.btn3 {
  border: 1px #c71628 solid;
  outline: none;
  border-radius: 0.02rem;
  background: none;
  min-width: 1.38rem;
  height: 0.29rem;
  align-items: center;
  justify-content: center;
  text-align: center;
  text-align: center;
  color: #c71628;
  font-size: 0.16rem;
  cursor: pointer;
  padding: 0 0.2rem;
  white-space: nowrap;
}
.rBtn1 {
  border: 0.02rem #ffffff solid;
  outline: none;
  border-radius: 0.2rem;
  background: none;
  min-width: 1.1rem;
  height: 0.36rem;
  line-height: 0.36rem;
  text-align: center;
  color: #ffffff;
  font-size: 0.16rem;
  cursor: pointer;
  box-sizing: border-box;
}
.rBtn1.active {
  background: #ffffff;
  color: #c71628;
}
.rBtn2 {
  border: 0.01rem #ffffff solid;
  outline: none;
  border-radius: 0.2rem;
  background: none;
  width: 1.05rem;
  height: 0.33rem;
  line-height: 0.33rem;
  text-align: center;
  color: #ffffff;
  font-size: 0.16rem;
  cursor: pointer;
}

.swiper-container2,
.swiper-container3,
.swiper-container4 {
  position: relative;

  .swiper-wrapper {
    align-items: center;
    width: auto !important;
    position: relative;
  }
  .swiper-pagination1 {
    text-align: center;
    position: absolute;
    bottom: 0.1rem !important;
    left: 0;
  }
  .swiper-pagination2 {
    text-align: center;
    position: absolute;
    bottom: -0.2rem !important;
    left: 0;
  }
  .swiper-pagination-bullet-active {
    background: #c71628;
  }
}
.swiper-container3 {
  padding-bottom: 0.4rem;
  .swiper-pagination-bullet-active {
    background: #fff;
  }
}
.el-popover {
  position: absolute;
  background-color: rgba(242, 240, 240, 0.9) !important;
  min-width: 1.5rem;
  border: 0.01rem solid #ebeef5;
  padding: 0 !important;
  z-index: 2000;
  color: #606266;
  line-height: 1.4;
  text-align: justify;
  font-size: 0 14rem;
  -webkit-box-shadow: 0 0.2rem 0.12rem 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0 0.02rem 0.12rem 0 rgba(0, 0, 0, 0.1);
  word-break: break-all;
}
.el-popper[x-placement^="bottom"] .popper__arrow::after {
  border-bottom-color: rgba(242, 240, 240, 0.9);
}
.el-popper[x-placement^="bottom"] {
  margin-top: 0.12rem;
}
.el-popover,
.el-radio-button:first-child:last-child .el-radio-button__inner {
  border-radius: 0.04rem;
}

.slide-up-enter-active {
  transition: all 0.3s ease;
}
.slide-up-enter, .slide-up-leave-to
/* .slide-fade-leave-active for below version 2.1.8 */ {
  transform: translateY(0.4rem);
  opacity: 0;
}

.slide-fade-enter,
.slide-fade-leave-to {
  opacity: 0;
}
.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: opacity 1s;
}

.swType1 .swiper-pagination-bullet {
  width: 0.08rem;
  height: 0.08rem;
  background: #ffffff;
  opacity: 0.5;
}
.swType1 .swiper-pagination-bullet-active {
  background: #ffffff;
  opacity: 1;
}
.swType1 .swiper-button-prev,
.swiper-button-next {
  width: 0.32rem;
  height: 0.54rem;
  margin-top: -0.27rem;
  color: #ffffff;
}
.swType1 .swiper-button-prev:after,
.swiper-button-next:after {
  font-size: 0.44rem;
}
.swType1
  .swiper-container-horizontal
  > .swiper-pagination-bullets
  .swiper-pagination-bullet {
  margin: 0 0.1rem;
}
.swType1 .swiper-pagination-fraction,
.swiper-pagination-custom,
.swiper-container-horizontal > .swiper-pagination-bullets {
  bottom: 0.02rem;
}

.swType2 .swiper-pagination-bullet {
  width: 0.08rem;
  height: 0.08rem;
  background: #f2f0f0;
  opacity: 1;
}
.swType2 .swiper-pagination-bullet-active {
  background: #c71628;
  opacity: 1;
}
.swiper-container1 .swiper-pagination-bullet-active {
  background: #f2f0f0;
  opacity: 1;
}
.swiper-container1 {
  .swiper-button-prev,
  .swiper-button-next {
    color: #ffffff;
    width: 0.32rem;
    height: 0.54rem;
    margin-top: -0.27rem;
    &:active,
    &:focus {
      outline-color: transparent !important;
      outline-style: none !important;
      outline-width: 0px !important;
      background-color: transparent !important;
    }
  }
  .swiper-button-prev:after,
  .swiper-button-next:after {
    font-size: 0.4rem !important;
    color: #ffffff;
  }
  .swiper-button-prev {
    left: 0.06rem;
  }
  .swiper-button-next {
    right: 0.1rem;
  }
  .swiper-pagination-bullets {
    bottom: -0.22rem !important;
  }
}

.swType2
  .swType2
  .swiper-container-horizontal
  > .swiper-pagination-bullets
  .swiper-pagination-bullet {
  margin: 0 0.1rem;
}
.swType2 .swiper-pagination-fraction,
.swiper-pagination-custom,
.swiper-container-horizontal > .swiper-pagination-bullets {
  bottom: 0.02rem;
}

.swType3 .swiper-pagination-bullet {
  width: 0.08rem;
  height: 0.08rem;
  background: #e1a3b0;
  opacity: 1;
}
.swType3 .swiper-pagination-bullet-active {
  background: #b31536;
  opacity: 1;
}
.swType3
  .swType3
  .swiper-container-horizontal
  > .swiper-pagination-bullets
  .swiper-pagination-bullet {
  margin: 0 0.1rem;
}
.swType3 .swiper-pagination-fraction,
.swiper-pagination-custom,
.swiper-container-horizontal > .swiper-pagination-bullets {
  bottom: -0.04rem;
}

.underline {
  text-decoration: underline;
  color: #ffffff;
}
.f44 {
  color: #ffffff;
  font-size: 0.44rem;
}
.f25 {
  color: #ffffff;
  font-size: 0.25rem;
}
.f30 {
  color: #ffffff;
  font-size: 0.3rem;
}
.f35 {
  color: #ffffff;
  font-size: 0.35rem;
}
.f20 {
  color: #ffffff;
  font-size: 0.2rem;
}
.f16 {
  color: #ffffff;
  font-size: 0.16rem;
}
.fb35 {
  color: #ffffff;
  font-size: 0.35rem;
  font-weight: bold;
}
.fb20 {
  color: #ffffff;
  font-size: 0.2rem;
  font-weight: bold;
}
.e18 {
  color: #3e3e3e;
  font-size: 0.18rem;
}
.e20 {
  color: #3e3e3e;
  font-size: 0.2rem;
}
.eb35 {
  color: #3e3e3e;
  font-size: 0.35rem;
  font-weight: bold;
}
.eb18 {
  color: #3e3e3e;
  font-size: 0.18rem;
  font-weight: bold;
}
.eb20 {
  color: #3e3e3e;
  font-size: 0.2rem;
  font-weight: bold;
}
.eb28 {
  color: #3e3e3e;
  font-size: 0.28rem;
  font-weight: bold;
}
.bb35 {
  color: #000000;
  font-size: 0.35rem;
  font-weight: bold;
}
.bb30 {
  color: #000000;
  font-size: 0.3rem;
  font-weight: bold;
}
.bb20 {
  color: #000000;
  font-size: 0.2rem;
  font-weight: bold;
}
.bb16 {
  color: #000000;
  font-size: 0.16rem;
  font-weight: bold;
}
.r16 {
  color: #c71628;
  font-size: 0.16rem;
}
.rb28 {
  color: #c71628;
  font-size: 0.28rem;
  font-weight: bold;
}
.rb20 {
  color: #c71628;
  font-size: 0.2rem;
  font-weight: bold;
}
.rb2_25 {
  color: #b31536;
  font-size: 0.25rem;
  font-weight: bold;
}
.rb2_20 {
  color: #b31536;
  font-size: 0.2rem;
}
.rb2_28 {
  color: #b31536;
  font-size: 0.25rem;
}
.g35 {
  color: #371b2f;
  font-size: 0.35rem;
}
.g20 {
  color: #371b2f;
  font-size: 0.2rem;
}

.addContainer {
  width: 19.2rem;
  position: relative;
  margin: 0 auto;
  height: 100%;
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.messageboard {
  .el-input__inner {
    height: 34px !important;

    &:focus {
      border-color: #6a6a6a;
      outline: 0;
    }
  }
  .a {
    .el-input__inner {
      width: calc(100%) !important;
      padding: 0;
      &:nth-last-of-type(1) {
        padding-left: 15px;
      }
    }
    .el-select .el-input {
      width: 80px;
    }
    .el-input-group__prepend .el-select {
      margin: 0;
      box-sizing: border-box;
    }
    .el-input__suffix {
      right: -1px;
      top: 2px;
      transform-origin: center center;
    }
    .el-select {
      .el-input.is-focus .el-input__inner {
        border-color: transparent !important;
        outline: 0;
      }
    }
  }
  .input-with-select .el-input-group__prepend {
    background-color: #fff;
    height: 34px !important;
    box-sizing: border-box;
    padding: 0 4px;
  }

  .el-select {
    width: 100%;
    height: 32px;
    .el-input.is-focus .el-input__inner {
      border-color: #6a6a6a;
      outline: 0;
    }
  }
  .el-form-item.is-required {
    margin-bottom: 25px;
    height: 34px !important;
  }
  .el-form-item__content {
    text-align: center;
  }
  .el-select .el-input .el-select__caret {
    transform-origin: center center;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
@media screen and (max-width: 750px) {
  button:active {
    color: #fff;
    background-color: red;
    //border-color: #adadad;
  }
  button:hover {
    color: #fff;
    background-color: transparent !important;
    //border-color: #adadad;
  }
  .messageboard {
    .el-input__inner {
      height: 0.64rem !important;
      line-height: 0.64rem;
      &:focus {
        border-color: #6a6a6a;
        outline: 0;
      }
    }
    .a {
      .el-input__inner {
        width: calc(100%) !important;
        padding: 0;
        &:nth-last-of-type(1) {
          padding-left: 0.3rem;
        }
      }
      .el-select .el-input {
        width: 1.6rem;
      }
      .el-input-group__prepend .el-select {
        margin: 0;
        box-sizing: border-box;
      }
      .el-input__suffix {
        right: 0.01rem;
        top: -0rem;
        transform-origin: center center;
      }
      .el-select {
        .el-input.is-focus .el-input__inner {
          border-color: transparent !important;
          outline: 0;
        }
      }
    }
    .input-with-select .el-input-group__prepend {
      background-color: #fff;
      height: 0.6rem !important;
      box-sizing: border-box;
      padding: 0 0.04rem;
    }

    .el-select {
      width: 100%;
      height: 0.6rem;
      .el-input.is-focus .el-input__inner {
        border-color: #6a6a6a !important;
        outline: 0;
      }
    }

    .el-form-item.is-required {
      margin-bottom: 0.6rem;
      height: 0.6rem !important;
      line-height: 0.6rem;
    }
    .el-form-item__content {
      text-align: center;
    }
    .el-select .el-input .el-select__caret {
      transform-origin: center center;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
.el-select-dropdown__item.selected {
  color: #000 !important;
  font-weight: 700;
}
.el-select .el-input__inner:focus {
  border-color: #6a6a6a;
}
.el-scrollbar {
  > .el-scrollbar__bar {
    opacity: 1 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue